import popupStyles from "./errorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { tWithKeyAttr as t } from "../../../i18nHelper";


function SupportSuccessPopup({
  onClose,
  text = t('SOMETHING_WENT_WRONG_TRY_AGAIN'),
  actionText,
  onAction,
}: IPopupWithoutProps & { text?: string; actionText?: string; onAction?: () => void }) {
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>{text}</h2>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >{t('CONFIRM')}</button>
      {actionText && onAction && (
        <button
          className={`button hover ${popupStyles.popup__nextBtn}`}
          onClick={onAction}
        >{actionText}</button>
      )}
    </article>
  );
}

export default SupportSuccessPopup;
